import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { Slider, Select } from "antd";

import ProductCard from "../card/ProductCard";
import Footer from "../layouts/Footer";
import { listProduct, searchFilters } from "../function/product";
import { listCategory } from "../function/category";
import { listCategoryService } from "../function/categoryservice";

import "./Shop.css";

const { Option } = Select;

const Shop = () => {
  const [product, setProduct] = useState([]);
  const [loading, setLoading] = useState(false);
  const [price, setPrice] = useState([0, 0]);
  const [ok, setOk] = useState(false);

  const [category, setCategory] = useState([]);
  const [categorySelect, setCategorySelect] = useState([]);
  const [categoryType, setCategoryType] = useState("");

  const { search } = useSelector((state) => ({ ...state }));
  const { text } = search;
  const location = useLocation();


  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const loadData = () => {
    setLoading(true);
    listProduct(100)
      .then((res) => {
        setProduct(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log("Load Data Error:", err);
      });
  };

  const fetchDataFilter = (arg) => {
    searchFilters(arg)
      .then((res) => setProduct(res.data))
      .catch((err) => console.log("Search Filter Error:", err));
  };

  // Handle text search
  useEffect(() => {
    const delay = setTimeout(() => {
      const params = new URLSearchParams(location.search);
      const categoryId = params.get("categoryId");
      const categoryType = params.get("categoryType");

      // ✅ ถ้ามี keyword ค้นหา → ใช้มันก่อนเลย
      if (text && text.trim() !== "") {
        fetchDataFilter({ query: text });
      }
      // ✅ ถ้ามี category จาก URL → ใช้หมวดหมู่
      else if (categoryId && categoryType) {
        fetchDataFilter({ category: [categoryId] });
      }
      // ✅ ไม่มีอะไรเลย → โหลดทั้งหมด
      else {
        loadData();
      }
    }, 300);

    return () => clearTimeout(delay);
  }, [text, location.search]);

  useEffect(() => {
    if (text && text.trim() !== "") {
      fetchDataFilter({ query: text });
    }
  }, [text]);

  // Handle price filter
  useEffect(() => {
    if (ok) fetchDataFilter({ price });
  }, [ok]);

  const handlePrice = (value) => {
    setPrice(value);
    setTimeout(() => setOk(!ok), 300);
  };
  const handlePriceInput = (e, index) => {
  const value = e.target.value === "" ? "" : parseInt(e.target.value);
  const newPrice = [...price];

  newPrice[index] = value;
  setPrice(newPrice);

  // ถ้ามีอย่างน้อย 1 ช่องถูกกรอก (ไม่ใช่ค่าว่าง) ค่อย trigger การค้นหา
  if (newPrice[0] !== "" || newPrice[1] !== "") {
    setTimeout(() => setOk(!ok), 300);
  }
};

  const handleCategoryChange = (value) => {
    setCategorySelect(value);
    if (value.length > 0) {
      fetchDataFilter({ category: value });
    } else {
      loadData();
    }
  };

  const handleCategoryTypeChange = (value) => {
    setCategoryType(value);
    setCategorySelect([]);
    if (value === "category") {
      listCategory().then((res) => setCategory(res.data));
    } else if (value === "categoryservice") {
      listCategoryService().then((res) => setCategory(res.data));
    }
  };

  // Load category from URL param
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const categoryTypeFromUrl = params.get("categoryType");
    const categoryIdFromUrl = params.get("categoryId");
    const categorySlugFromUrl = params.get("category");

    setCategoryType(categoryTypeFromUrl || "");

    const fetchCategoriesAndFilter = async () => {
      let categoriesData = [];
      if (categoryTypeFromUrl === "category") {
        const res = await listCategory();
        categoriesData = res.data;
        setCategory(res.data);
      } else if (categoryTypeFromUrl === "categoryservice") {
        const res = await listCategoryService();
        categoriesData = res.data;
        setCategory(res.data);
      } else {
        setCategory([]);
      }


      let selectedCategoryId = null;
      if (categoryIdFromUrl) {
        selectedCategoryId = categoryIdFromUrl;
      } else if (categorySlugFromUrl) {
        const found = categoriesData.find((item) => item.slug === categorySlugFromUrl);
        if (found) {
          selectedCategoryId = found._id;
        }
      }

      console.log("categoryTypeFromUrl:", categoryTypeFromUrl);
      console.log("categoryIdFromUrl:", categoryIdFromUrl);
      console.log("categorySlugFromUrl:", categorySlugFromUrl);
      console.log("selectedCategoryId:", selectedCategoryId);

      if (selectedCategoryId) {
        setCategorySelect([selectedCategoryId]);
        fetchDataFilter({ category: [selectedCategoryId] });
      } else {
        loadData();
      }
    };

    fetchCategoriesAndFilter();
  }, [location.search]);


  return (
    <div className="container-fluid mt-2">
      <div className="row mt-2">
        {/* Sidebar */}
        <div className="col-md-2 sidebar-filter" style={{ backgroundColor: "#e1f8cd33", padding: "10px" }}>
          <div className="row mt-1">
            <div className="col-md-12 mt-5">
              <h5>Filter / Search</h5>
            <hr />
            </div>
            
            <div className="col-md-12">
                <h6>ค้นหาด้วยราคา</h6>
            {/* <Slider value={price} onChange={handlePrice} range max={50000} /> */}
            
            <div className="d-flex gap-2">
              <input
                type="number"
                className="form-control"
                placeholder="Min"
                value={price[0]}
                onChange={(e) => handlePriceInput(e, 0)}
              />
              <input
                type="number"
                className="form-control"
                placeholder="Max"
                value={price[1]}
                onChange={(e) => handlePriceInput(e, 1)}
              />
            </div>
            <hr />
            </div>
            

          </div>

          <div className="row mt-1">
            <div className="col-6 mt-1 col-md-12">
              <h6>ประเภทหมวดหมู่</h6>
              <Select
                style={{ width: "100%" }}
                value={categoryType}
                onChange={handleCategoryTypeChange}
                placeholder="เลือกประเภทหมวดหมู่"
              >
                <Option value="category">หมวดหมู่ของสินค้า 360</Option>
                <Option value="categoryservice">หมวดหมู่สินค้าบริการ</Option>
              </Select>
            </div>

            <div className="col-6 mt-1 col-md-12">
              <h6>ค้นหาตามหมวดหมู่</h6>
              <Select
                mode="multiple"
                style={{ width: "100%" }}
                value={categorySelect}
                onChange={handleCategoryChange}
                placeholder="เลือกหมวดหมู่"
              >
                {category.map((item) => (
                  <Option key={item._id} value={item._id}>
                    {item.name}
                  </Option>
                ))}
              </Select>
            </div>
          </div>
        </div>

        {/* Product list */}
        <div className="col-md-9 d-flex flex-column mt-5">
          {loading ? (
            <h4 className="text-danger">Loading...</h4>
          ) : (
            <h4 className="text-info">Product</h4>
          )}

          {product.length === 0 && <p>No Product found</p>}

          <div className="row g-1 mt-2">
            {product.map((item, index) => (
              <div key={index} className="col-6 col-sm-6 col-md-4 col-lg-3 mb-4">
                <ProductCard product={item} />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* <Footer /> */}
    </div>
  );
};

export default Shop;
